module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6ef72eb649e5b52e25bb2c1f92aa5334.png";